import {
    BANKER_LOGIN,
    CONFIRM_BANKER_EMAIL_OTP,
    GET_BANKER_INFORMATION_BY_BANKER_ID,
    SEND_Banker_VERIFY_EMAIL_OTP,
    UPDATE_BANKER_DATA,
    ADD_UPDATE_SPONSER,
    GET_SPONSER_DATA_BY_ID,
    GET_SPONSER_DATA_BY_BANKER_EMAIL_ID,
    DELETE_SPONSER_BY_ID,
    RESEND_EMAIL_WITH_LINK_AND_PASS,
    GET_SPONSER_LIST_BY_BANKER_ID,
    DELETE_SPONSER_APPLICANT_BY_ID,
    FORGOT_BANKER_PASSWORD,
    GET_BANKER_DASHBOARD_SUMMARY_BY_BANKER_ID,
    ADD_OR_UPDATE_BANKER_METRICS_DATA,
    GET_BANKER_METRICS_BY_BANKER_ID,
    GET_BANKER_LOAN_APPLICATION_SUMMARY,
    GET_ALL_LOAN_APPLICATION_LIST_BY_BANKER_ID,
    GET_APPLICATION_LIST_BY_SPONSER_ID,
    GET_BANKER_REVISIT_APPLICATION_LIST_BY_BANKER_ID,
    ADD_OR_UPDATE_RISK_FREE_LOAN_DATA,
    GET_RISK_FREE_LOAN_BY_APPLICANT_ID,
    ADD_APPLICATION_REVIEW_COMMENT,
    GET_APPLICATION_REVIEW_COMMENT_FOR_BANKER,
    CHANGE_BANKER_PASSWORD,
    UPDATE_APPLICANT_STATUS,
    RESEND_SPONSER_APPLICANT_EMAIL_OTP,
    DELETE_SPONSER_APPLICANTS_DATA,
    FORGOT_PASSWORD_SEND_EMAIL_OTP,
    GET_ADMINISTRATOR_COUNT
} from "../constants/constants";
import { instance } from "./apiRequest";

let _AdministratorService = {
    async sendVerifyEmailOTP(obj) {
        return await instance.post(SEND_Banker_VERIFY_EMAIL_OTP, obj);
    },
    async confirmEmailOTP(obj) {
        return await instance.post(CONFIRM_BANKER_EMAIL_OTP, obj);
    },
    async updateBankerData(reqObj) {
        return await instance.post(UPDATE_BANKER_DATA, reqObj);
    },
    async bankerLogin(obj) {
        return await instance.post(BANKER_LOGIN, obj);
    },
    async getBankerInformationByBankerId(bankerId) {
        let url = GET_BANKER_INFORMATION_BY_BANKER_ID + "?bankerId=" + bankerId;
        return await instance.get(url);
    },
    async addUpdateSponser(obj) {
        return await instance.post(ADD_UPDATE_SPONSER, obj);
    },
    async getSponserDataBySponserId(sponserId) {
        let url = GET_SPONSER_DATA_BY_ID + "?sponserId=" + sponserId;
        return await instance.get(url);
    },
    async getSponserDataByBankerEmailId(bankerEmailId) {
        let url = GET_SPONSER_DATA_BY_BANKER_EMAIL_ID + "?applicantEmail=" + bankerEmailId;
        return await instance.get(url);
    },
    async deleteSponserBySponserId(sponserId) {
        let url = DELETE_SPONSER_BY_ID + "?sponserId=" + sponserId;
        return await instance.get(url);
    },
    async resendEmailWithLinkAndPasscode(emailId) {
        let url = RESEND_EMAIL_WITH_LINK_AND_PASS + "?email=" + emailId;
        return await instance.get(url);
    },
    async getSponserListByBankerId(bankerId) {
        let url = GET_SPONSER_LIST_BY_BANKER_ID + "?bankerId=" + bankerId;
        return await instance.get(url);
    },
    async deleteSponserApplicantById(applicantId) {
        let url = DELETE_SPONSER_APPLICANT_BY_ID + "?Id=" + applicantId;
        return await instance.post(url);
    },
    async forgotBankerPassword(reqObj) {
        return await instance.post(FORGOT_BANKER_PASSWORD, reqObj);
    },
    async getBankerDashboardSummaryByBankerId(bankerId) {
        let url = GET_BANKER_DASHBOARD_SUMMARY_BY_BANKER_ID + "?bankerId=" + bankerId;
        return await instance.get(url);
    },
    async addOrUpdateBankerMetricsData(reqObj) {
        return await instance.post(ADD_OR_UPDATE_BANKER_METRICS_DATA, reqObj);
    },
    async getBankerMetricsByBankerIDAndSponserId(bankerId, sponserId) {
        let url = GET_BANKER_METRICS_BY_BANKER_ID + "?bankerId=" + bankerId + "&sponserId=" + sponserId;
        return await instance.get(url);
    },
    async getBankerLoanApplicationMonthlySummaryByBankerId(bankerId) {
        let url = GET_BANKER_LOAN_APPLICATION_SUMMARY + "?bankerId=" + bankerId;
        return await instance.get(url);
    },
    // async getAllLoanApplicationListByBankerId({ bankerId, startDate = "", endDate = "", pageIndex = 1, pageSize = 10, searchTerm = "", sortBy = "id", sortAsc = false }) {
    //     let url = `${GET_ALL_LOAN_APPLICATION_LIST_BY_BANKER_ID}?bankerId=${bankerId}&startDate=${startDate}&endDate=${endDate}&pageIndex=${pageIndex}&pageSize=${pageSize}&searchTerm=${searchTerm}&sortBy=${sortBy}&sortAsc=${sortAsc}`;
    //     return await instance.get(url);
    // },

    async getAllLoanApplicationListByBankerId({
        bankerId, ByAppStatus, startDate, endDate, pageIndex, pageSize, searchTerm, sortBy, sortAsc
    }) {
        let appStatus = ByAppStatus ? ByAppStatus : 0;

        let queryString =
            "?bankerId=" +
            bankerId +
            "&pageIndex=" +
            pageIndex +
            "&pageSize=" +
            pageSize +
            "&ByAppStatus=" +
            appStatus;

        // if (ByAppStatus && ByAppStatus != "") {
        //     queryString = queryString + "&ByAppStatus=" + ByAppStatus;
        // }
        if (searchTerm && searchTerm != "") {
            queryString = queryString + "&searchTerm=" + searchTerm;
        }
        if (startDate && startDate != "" && endDate && endDate != "") {
            queryString = queryString + "&startDate=" + startDate + "&endDate=" + endDate;
        }
        if (sortBy && sortBy != "") {
            let sortBytext = (sortBy == "newest" || sortBy == "oldest") ? "createddate" : "app_det_loanamount";
            queryString = queryString + "&sortBy=" + sortBytext;
        }
        if (sortAsc && sortAsc != "") {
            let sortBytext = (sortBy == "oldest" || sortBy == "high") ? false : true;
            queryString = queryString + "&sortAsc=" + sortBytext;
        }
        return await instance.get(GET_ALL_LOAN_APPLICATION_LIST_BY_BANKER_ID + queryString);
    },

    // async getApplicationListBySponserId(sponserId, pageIndex, pageSize, searchTerm, sortBy, sortAsc, startDate, endDate) {
    //     let url = GET_APPLICATION_LIST_BY_SPONSER_ID + "?sponserId=" + sponserId
    //     // + "&pageIndex=" + pageIndex +
    //     //     "&pageSize=" + pageSize + "&searchTerm=" + searchTerm + "&sortBy=" + sortBy + "&sortAsc=" + sortAsc +
    //     //     "&startDate=" + startDate + "&endDate=" + endDate;
    //     return await instance.get(url);
    // },

    async getApplicationListBySponserId({
        sponserId, ByAppStatus, startDate, endDate, pageIndex, pageSize, searchTerm, sortBy, sortAsc }) {
        let queryString =
            "?sponserId=" +
            sponserId +
            "&pageIndex=" +
            pageIndex +
            "&pageSize=" +
            pageSize +
            "&ByAppStatus=" +
            ByAppStatus;


        // if (ByAppStatus && ByAppStatus != "") {
        //     queryString = queryString + "&ByAppStatus=" + ByAppStatus;
        // }
        if (searchTerm && searchTerm != "") {
            queryString = queryString + "&searchTerm=" + searchTerm;
        }
        if (startDate && startDate != "" && endDate && endDate != "") {
            queryString = queryString + "&startDate=" + startDate + "&endDate=" + endDate;
        }
        if (sortBy && sortBy != "") {
            let sortBytext = (sortBy == "newest" || sortBy == "oldest") ? "createddate" : "app_det_loanamount";
            queryString = queryString + "&sortBy=" + sortBytext;
        }
        if (sortAsc && sortAsc != "") {
            let sortBytext = (sortBy == "oldest" || sortBy == "high") ? false : true;
            queryString = queryString + "&sortAsc=" + sortBytext;
        }
        return await instance.get(GET_APPLICATION_LIST_BY_SPONSER_ID + queryString);
    },

    async getBankerRevistApplicationListByBankerId({ bankerId, startDate = "", endDate = "", pageIndex = 1, pageSize = 10, searchTerm = "", sortBy = "id", sortAsc = false }) {
        let url = `${GET_BANKER_REVISIT_APPLICATION_LIST_BY_BANKER_ID}?bankerId=${bankerId}&startDate=${startDate}&endDate=${endDate}&pageIndex=${pageIndex}&pageSize=${pageSize}&searchTerm=${searchTerm}&sortBy=${sortBy}&sortAsc=${sortAsc}`;
        return await instance.get(url);
    },
    async addOrUpdateRiskFreeLoanData(reqObj) {
        return await instance.post(ADD_OR_UPDATE_RISK_FREE_LOAN_DATA, reqObj);
    },
    async getRiskFreeLoanByApplicantId(applicationId) {
        let url = GET_RISK_FREE_LOAN_BY_APPLICANT_ID + "?applicationId=" + applicationId;
        return await instance.get(url);
    },
    async addApplicationReviewComment(reqObj) {
        return await instance.post(ADD_APPLICATION_REVIEW_COMMENT, reqObj);
    },
    async getApplicationReviewCommentForBanker(applicationId, bankerId) {
        let url = GET_APPLICATION_REVIEW_COMMENT_FOR_BANKER + "?applicationId=" + applicationId + "&bankerId=" + bankerId;
        return await instance.get(url);
    },

    async ChangeBankerPassword(reqObj) {
        return await instance.post(CHANGE_BANKER_PASSWORD, reqObj);
    },
    async updateApplicantStatus(reqObj) {
        return await instance.post(UPDATE_APPLICANT_STATUS, reqObj);
    },
    async resendApplicantEmailOTP(reqObj) {
        return await instance.post(RESEND_SPONSER_APPLICANT_EMAIL_OTP, reqObj);
    },
    async deleteSponserApplicantsData(reqObj) {
        return await instance.post(DELETE_SPONSER_APPLICANTS_DATA, reqObj);
    },
    async forgotPasswordSendEmailOTP(obj) {
        return await instance.post(FORGOT_PASSWORD_SEND_EMAIL_OTP, obj);
    },
    async getAdministratorCount() {
        let url = GET_ADMINISTRATOR_COUNT;
        return await instance.get(url);
    }
}
export default _AdministratorService;